module.exports = __webpack_public_path__ + "static/media/slider01.521b16f7.jpg";